import React, { useEffect } from "react";
import { SITE_NAME, REPO_URL } from "../constants/siteConfig";

export default function AboutPage({ onClose, shipCount, onOpenContact, onOpenPrivacy, onOpenTerms }) {
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <div className="legal-backdrop" onClick={onClose}>
      <article className="legal-modal" role="dialog" aria-label={`About ${SITE_NAME}`} onClick={(e) => e.stopPropagation()}>
        <header>
          <h2>About {SITE_NAME}</h2>
          <button className="slide-panel-close" onClick={onClose} aria-label="Close">×</button>
        </header>

        <div className="legal-body">
          <p>
            {SITE_NAME} is a free, community-built map of shipwrecks.
            {shipCount > 0 && <> Right now it lists <strong>{shipCount}</strong> wrecks.</>}{" "}
            Anyone can browse the map without an account. Anyone with an account can add wrecks, suggest
            corrections and help keep the record accurate.
          </p>

          <h3>How it works</h3>
          <ul>
            <li>
              <strong>Browse.</strong> Pan the map, search by name, type, owner or <strong>boat ID</strong>
              {" "}(try <code>#12</code>), and open a wreck for its full details, photos and history.
            </li>
            <li>
              <strong>Contribute.</strong> Log in and use <em>Submit a shipwreck</em>. Only a name and a location
              are required; the more you add (dates, builder, sources), the better.
            </li>
            <li>
              <strong>Review.</strong> New wrecks and edits are checked by an admin before they appear on the map.
              Every approved change is recorded in the public <em>Recent changes</em> feed.
            </li>
            <li>
              <strong>Credit.</strong> Contributors are credited by username and earn points on the leaderboard.
            </li>
          </ul>

          <h3>Photos and attribution</h3>
          <p>
            Every photo must be credited to whoever took it or the place it came from, and that credit is shown
            beside the photo. Please only submit photos you took or that are free to reuse. If you are the
            photographer or rights holder and want a photo credited differently or removed, see the{" "}
            <button type="button" className="panel-link" onClick={onOpenContact}>Contact page</button>.
          </p>

          <h3>Open data</h3>
          <p>
            Approved wreck records can be downloaded as <a href="/api/export?format=geojson">GeoJSON</a> or{" "}
            <a href="/api/export?format=csv">CSV</a>. Photos and photo credits are not included in the exports.
          </p>

          <h3>Open source</h3>
          <p>
            The project's code lives on{" "}
            <a href={REPO_URL} target="_blank" rel="noopener noreferrer">GitHub</a>. Bug reports and ideas are welcome there.
          </p>

          <h3>The fine print</h3>
          <p>
            Please read the{" "}
            <button type="button" className="panel-link" onClick={onOpenTerms}>Terms and Conditions</button> and the{" "}
            <button type="button" className="panel-link" onClick={onOpenPrivacy}>Privacy Policy</button>.
            Wreck locations and details are community-submitted and may be wrong. Do not use {SITE_NAME} for navigation or
            as a substitute for official charts, and respect protected wrecks and war graves.
          </p>
        </div>

        <footer>
          <button className="panel-primary" onClick={onClose}>Close</button>
        </footer>
      </article>
    </div>
  );
}
